import { FC, useEffect } from 'react';
import IncomingDocumentAddEditBaseView from './base';
import store from "./store"
import { observer } from "mobx-react"
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomButton from 'components/Button';

type PopupFormProps = {
  openPanel: boolean;
  id: number;
  onBtnCancelClick: () => void;
  onSaveClick: (id: number) => void;
}

const IncomingDocumentPopupForm: FC<PopupFormProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;

  useEffect(() => {
    if (props.openPanel) {
      store.doLoad(props.id)
    } else {
      store.clearStore()
    }
  }, [props.openPanel])

  return (
    <Dialog open={props.openPanel} onClose={props.onBtnCancelClick} maxWidth="sm" fullWidth>
      <DialogTitle>{translate('label:incomingDocumentAddEditView.entityTitle')}</DialogTitle>
      <DialogContent>
        <IncomingDocumentAddEditBaseView
          isPopup={true}
        >
        </IncomingDocumentAddEditBaseView>
      </DialogContent>
      <DialogActions>
        <CustomButton
          variant="contained"
          id="id_incomingDocumentSaveButton"
          name={'incomingDocumentAddEditView.save'}
          onClick={() => {
            store.onSaveClick((id: number) => props.onSaveClick(id))
          }}
        >
          {translate("common:save")}
        </CustomButton>
        <CustomButton
          variant="contained"
          id="id_incomingDocumentCancelButton"
          name={'incomingDocumentAddEditView.cancel'}
          onClick={() => props.onBtnCancelClick()}
        >
          {translate("common:cancel")}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
})

export default IncomingDocumentPopupForm